import { useEffect, useState, type FormEvent } from "react";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { LoadingState } from "../components/LoadingState";
import { centsToInput, yuanToCents } from "../utils/currency";

export function SettingsPage() {
  const [limit, setLimit] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.getSettings()
      .then((settings) => setLimit(centsToInput(settings.daily_expense_limit_cents)))
      .catch((caught) => setError(caught instanceof Error ? caught.message : "设置加载失败。"))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    const cents = yuanToCents(limit);
    if (!cents) {
      setError("请输入大于 0、最多两位小数的金额。");
      return;
    }
    setSaving(true);
    setError("");
    setSaved(false);
    try {
      const settings = await api.updateSettings(cents);
      setLimit(centsToInput(settings.daily_expense_limit_cents));
      setSaved(true);
      window.dispatchEvent(new Event("ledger-data-changed"));
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "保存失败，请稍后重试。");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="page settings-page">
      <Link className="back-link" to="/"><ArrowLeft size={18} />返回日历</Link>
      <section className="settings-heading">
        <p className="eyebrow">账本偏好</p>
        <h1>设置</h1>
        <p>界限用于标记每天的支出状态，修改后会立即影响整个月历。</p>
      </section>
      <section className="settings-card">
        {loading ? <LoadingState label="正在读取设置…" /> : (
          <form onSubmit={handleSubmit}>
            <label className="settings-field">
              <span>每日支出界限</span>
              <small>当日支出超过这个金额时，日期会标记为红色。</small>
              <span className="currency-input large"><b>¥</b><input inputMode="decimal" value={limit} onChange={(event) => { setLimit(event.target.value); setSaved(false); }} required /></span>
            </label>
            {error && <p className="form-error" role="alert">{error}</p>}
            {saved && <p className="save-success" role="status"><CheckCircle2 size={17} />设置已保存</p>}
            <button className="primary-button" type="submit" disabled={saving}>{saving ? "正在保存…" : "保存设置"}</button>
          </form>
        )}
      </section>
    </main>
  );
}
